import React from "react";
import classNames from "classnames";
import axios from "axios";

class AddReward extends React.Component {
  constructor(props) {
    super(props);
    this.state = { adding: false };
    this.statusRef = React.createRef();
    this.amountRef = React.createRef();
  }

  onAdd() {
    var data = {
      status: this.statusRef.current.value,
      amount: this.amountRef.current.value
    };

    this.setState({ adding: true });

    axios
      .post(`/admin/opportunities/${this.props.opportunity.id}/rewards`, data)
      .then(response => {
        this.props.onFinish();
      })
      .catch(() => {
        this.setState({ adding: false });
      });
  }

  render() {
    const { statuses, onFinish } = this.props;
    var btnClasses = classNames("button", "is-primary", {
      "is-loading": this.state.adding
    });

    return (
      <div className="field has-addons">
        <p className="control">
          <span className="select">
            <select ref={this.statusRef}>
              {statuses.map((status, idx) => <option key={idx}>{status}</option>)}
            </select>
          </span>
        </p>
        <p className="control is-expanded">
          <input
            className="input"
            ref={this.amountRef}
            type="text"
            placeholder="Amount of money"
          />
        </p>
        <p className="control">
          <a className={btnClasses} onClick={this.onAdd.bind(this)}>
            Add
          </a>
        </p>
      </div>
    );
  }
}

export default AddReward;
